import React from "react";
import { Row, Col, Form, FormGroup, Label, Input, Card, CardBody } from "reactstrap";
import { Formik } from "formik";
import { PolicySettingsValues, SettingsProps } from "../../types/settings";
import SettingsButtons from "./SettingsButtons";

const PolicySettings: React.FC<SettingsProps> = ({ 
  onGlobalCancel, 
  isSaving, 
  onSave 
}) => {
  const initialValues: PolicySettingsValues = {
    termsConditions: "",
    privacyPolicy: "",
    returnPolicy: "",
    showPolicyFooter: false,
    requirePolicyAccept: false,
    lastUpdated: new Date().toISOString().split('T')[0],
  };

  const handleSave = async (values: PolicySettingsValues) => {
    await onSave(async () => {
      console.log("Form submitted with values:", values);
      await new Promise(resolve => setTimeout(resolve, 1000));
      // TODO: Add actual API call here
    });
  };

  return (
    <div className="bg-transparent">
      <h5 className="mb-4">Policy Settings</h5>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSave}
      >
        {({
          values,
          handleChange,
          handleSubmit,
        }) => (
          <Form>
            <Card className="mb-4">
              <CardBody>
                <h6 className="mb-3">Terms & Conditions</h6>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="termsConditions">Terms & Conditions Content</Label>
                      <Input
                        type="textarea"
                        id="termsConditions"
                        name="termsConditions"
                        rows={6}
                        value={values.termsConditions}
                        onChange={handleChange}
                        placeholder="Enter your terms and conditions"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr className="my-4" />

                <h6 className="mb-3">Privacy Policy</h6>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="privacyPolicy">Privacy Policy Content</Label>
                      <Input
                        type="textarea"
                        id="privacyPolicy"
                        name="privacyPolicy"
                        rows={6}
                        value={values.privacyPolicy}
                        onChange={handleChange}
                        placeholder="Enter your privacy policy"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr className="my-4" />

                <h6 className="mb-3">Return Policy</h6>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="returnPolicy">Return Policy Content</Label>
                      <Input
                        type="textarea"
                        id="returnPolicy"
                        name="returnPolicy"
                        rows={6}
                        value={values.returnPolicy}
                        onChange={handleChange}
                        placeholder="Enter your return policy"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr className="my-4" />

                <h6 className="mb-3">Policy Display Settings</h6>
                <Row>
                  <Col md={6}>
                    <FormGroup check className="mb-3">
                      <Input
                        type="checkbox"
                        id="showPolicyFooter"
                        name="showPolicyFooter"
                        checked={values.showPolicyFooter}
                        onChange={handleChange}
                      />
                      <Label check for="showPolicyFooter">
                        Show in Footer
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup check className="mb-3">
                      <Input
                        type="checkbox"
                        id="requirePolicyAccept"
                        name="requirePolicyAccept"
                        checked={values.requirePolicyAccept}
                        onChange={handleChange}
                      />
                      <Label check for="requirePolicyAccept">
                        Require Acceptance at Checkout
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="lastUpdated">Last Updated Date</Label>
                      <Input
                        type="date"
                        id="lastUpdated"
                        name="lastUpdated"
                        value={values.lastUpdated}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <SettingsButtons
              onSave={handleSubmit}
              onCancel={onGlobalCancel}
              isSaving={isSaving}
              saveDisabled={false}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PolicySettings; 